import { ArchetypeDefinition } from '../../archetypeTypes';

export const LOVE_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'lover',
        name: 'Lover',
        description: 'Attunement, resonance, and energetic bonding.',
        category: 'Love',
        tags: ['attunement', 'bond', 'resonance'],
        weights: { voicePitch: 0.2, breathingQuality: 0.3, stability: 0.2, averageNodeEnergy: 0.3 }
    },
    {
        key: 'harmonist',
        name: 'Harmonist',
        description: 'Aligns rhythms and tones to create durable coherence.',
        category: 'Love',
        tags: ['harmony', 'attunement', 'coherence'],
        weights: { breathingQuality: 0.35, voicePitch: 0.25, stability: 0.25, linguisticComplexity: 0.15 }
    }
];


